var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login mt-4"},[_c('GoogleSignIn',{on:{"authenticated":_vm.handleAuthentication,"signed-out":_vm.handleSignOut}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }